<app-header></app-header>
<ng-container *ngIf="journeySettings$ | async; let settings">
  <app-offer-flow-easy-link *ngIf="settings.website" [website]="settings.website"></app-offer-flow-easy-link>
</ng-container>

<div class="offer-body">
  <div class="questions-c">
    <ng-container *ngIf="allQuestions.length > 0">
      <ng-container *ngFor="let question of allQuestions; trackBy: allQuestionsTrackBy">
        <ng-container *ngComponentOutlet="question.type;injector:question.injector"> </ng-container>
      </ng-container>
    </ng-container>
  </div>
</div>
